import React, { Component } from 'react'
import _ from 'underscore'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import { Col, Row } from 'react-bootstrap'
import CartItems from './cartItems'
import { activateExtra, toggleAdditionalService, cleanShoppingCartStore, setLimitDateAppointment, loadInitialsDatePickerValues, addReplacementVehicle, removeReplacementVehicle } from './actions'
import { switchCheckoutContent } from '../../workflow/checkout/checkoutContent/actions'
import './styles.css'
import moment from 'moment'
import Swal from 'sweetalert2'
import { configuration } from '../../configuration'

class ShoppingCart extends Component {

  constructor(props) {
    super(props)
    this.setLimitDateAppointment = this.setLimitDateAppointment.bind(this);
  }

  setLimitDateAppointment(tempHoursRange) {
    this.props.setLimitDateAppointment(tempHoursRange);
  }

  addAdditionalService = (additionalService) => {
    let items = this.props.cart.items

    //Compruebo si el servicio esta en el carro
    const additionalServiceIndex = _.findIndex(items, e => e.serviceId === additionalService.serviceId)

    //Compruebo si el servicio adicional tiene que mostrar un modal
    if (additionalServiceIndex == -1 && additionalService.showModal) {
      this.showModal(additionalService)

      //Si ya esta añadido al carrito y tengo que mostrar modal, entonces solo lanzo la accion del toggle
    } else if (additionalServiceIndex == 1 && additionalService.showModal) {
      this.props.removeReplacementVehicle()
      this.props.loadInitialsDatePickerValues()
      this.props.toggleAdditionalService(additionalService)
      //Si ya esta añadido al carrito o no tengo que mostrar modal, entonces solo lanzo la accion del toggle
    } else if (additionalServiceIndex == 1 || !additionalService.showModal) {
      this.props.toggleAdditionalService(additionalService)
    }
  }

  showModal = (additionalService) => {
    Swal.fire({
      text: 'El servicio de vehículo de cortesía está sujeto a disponibilidad del taller. Una vez que lo solicite el taller debe ponerse en contacto con usted para confirmarlo. Debe solicitar este servicio con al menos 48 horas de antelación.',
      showCancelButton: true,
      cancelButtonText: "CANCELAR",
      confirmButtonClass: 'jump button-primary',
      cancelButtonClass: 'jump button-secondary'

    }).then((result) => {

      //Si clico en OK
      if (result.value) {
        this.props.addReplacementVehicle();
        //tengo una cita ya cogida
        if (this.props.appointment && this.props.appointment.selectedDate && this.props.appointment.selectedTime) {
          let appointmentDate = this.props.appointment.selectedDate;
          let hour = this.props.appointment.selectedTime.split(':')[0];
          let minutes = this.props.appointment.selectedTime.split(':')[1];
          appointmentDate = appointmentDate.set('h', hour);
          appointmentDate = appointmentDate.set('h', minutes);

          //Compruebo si la cita que tengo actualmente es inferior al margen dado
          //Si es inferior redirijo a citas y limpio citas, ademas limito las citas
          this.clearFormValues();
          this.props.toggleAdditionalService(additionalService)
          let haveToRedirect = this.checkReservationdDfferenceDate(appointmentDate, hour, minutes, 5)
          if (haveToRedirect) {
            this.props.switchCheckoutContent('appointment')
            this.clearFormValues();
          }
        } else {
          this.clearFormValues()
          this.props.toggleAdditionalService(additionalService)
        }
      }
    })
  }

  //Limpio los valores del formulario del DatePicker si es ifnerior la cita  a 48h
  clearFormValues = () => {
    const appointmentDate = moment(this.props.appointment.selectedDate)
    if (this.props.appointment.selectedTime) {
      const time = this.props.appointment.selectedTime
      appointmentDate.set('hour', time.split(':')[0])
      appointmentDate.set('minute', time.split(':')[1])
    }
    const now = moment();
    if (appointmentDate.diff(now, 'hour') < 48) {
      this.props.loadFormValues('appointmentDataForm', 'appointment.date', '')
      this.props.loadFormValues('appointmentDataForm', 'appointment.time', '')
    }
  }

  // Devuelve true si la fecha de la cita es inferior al valor 'difference' pasado como parametro
  checkReservationdDfferenceDate = (appointmentDate, hour, minutes, difference) => {
    let now = moment()
    let reservationDate = moment(appointmentDate);
    reservationDate = moment(reservationDate).set('hour', hour)
    reservationDate = moment(reservationDate).set('minute', minutes)
    var daysOfDifference = reservationDate.diff(now, 'days');
    return daysOfDifference < difference
  }

  render() {
    const includes = configuration().includes || []
    const freeItems = this.props.recalls.concat(includes)

    const additionalServices = this.props.additionalServices;
    const filteredAdditionalServices = _.filter(additionalServices, function (o) {
      if (o.isRecommended) {
        return (moment().isBetween(o.dateRangeFrom, o.dateRangeTo));
      } else {
        return true;
      }
    })
    let items = this.props.cart.items
    let extras = _.reduce(items, function (memo, item) {
      return memo.concat(item.extras || [])
    }, [])

    let totalCost = items.reduce((value, element) => {
      const activeExtras = _.where(element.extras, { activate: true }) || [];
      let extrasCost = _.reduce(activeExtras, (memo, extra) => (memo + parseFloat(extra.price)), 0);
      return (
        (typeof element.price === 'number' && !_.isNaN(element.price))
          ? ((parseFloat(element.price) + parseFloat(extrasCost)) * parseFloat(configuration().ivaConfigTaxesSin) + parseFloat(value))
          : !_.isNaN(extrasCost) && extrasCost > 0
            ? (parseFloat(extrasCost) * parseFloat(configuration().ivaConfigTaxesSin) + parseFloat(value))
            : parseFloat(value) + parseFloat(0));
    }, 0);

    let hideCopy = this.props.hideCopy || false;

    const ticksColor = "ticksCaribou " + configuration().checkIconClass

    let displayCarData
    let displayIncludeTitle
    if (configuration().brandName && configuration().brandName.toLowerCase() === 'mazda') {
      if (this.props.carData) {
        displayCarData = <p>
          {this.props.carData.carModel} - {this.props.carData.carYear}
          <br />
          {this.props.currentUser && this.props.currentUser.plate}
        </p>
      }
      displayIncludeTitle = <h4><b>Campañas</b></h4>
    } else {
      if (this.props.carData) {
        const engine = configuration().showEngineInShoppingCart ? this.props.carData.carEngine.split(',')[0] : this.props.carData.carModel
        displayCarData = <p>
          {this.props.carData.carMake}
          <br />
          {engine}
          <br />
          {this.props.carData.carYear}
        </p>
      }
      displayIncludeTitle = <h4><b>Incluye</b></h4>
    }

    return (
      <div>
        {(items.length > 0 || hideCopy) ?

          <div id="shopping-cart">
            <div id="cart-header" style={{ backgroundColor: configuration().clientColor }}>
              <Row>
                <Col xs={6} md={6}><span className="price">{typeof totalCost === 'number' && !_.isNaN(totalCost) ? parseFloat(totalCost).toFixed(2) : '-.-'} €</span></Col>
                <Col xs={6} md={6}><span className="price-decription">Precio total {configuration().ivaConfigTotalText}</span></Col>
              </Row>
            </div>
            <div id="cart-content">
              <div id="car-description-content" className="row">
                <div className="car-description col-9">
                  {displayCarData}
                </div>
                <div className="col-3">
                  {
                    this.props.carData.carMake === "Renault" ?
                      <img src="../images/renault.png" width="70" height="75" className="img-car" /> :
                      (this.props.carData.carMake === "Dacia" ?
                        <img src="../images/dacia.png" width="70" height="75" className="img-car" /> :
                        (this.props.carData.carMake === "OPEL" ?
                          <img src="../images/opel.png" width="70" height="75" className="img-car" /> :
                          (this.props.carData.carMake === "Mazda" ?
                            <img src="../images/logo-mazda.png" width="70" className="img-car" /> :
                            (this.props.carData.carMake === "Kia" ?
                              <img src="../images/logo-kia-negro.png" width="100" height="100" className="img-car" /> :
                              (this.props.carData.carMake === "Mitsubishi" ?
                                <img src="../images/logo-Mitsubishi.png" width="100" height="100" className="img-car" /> :
                                <div />
                              )
                            )
                          )
                        )
                      )
                  }

                </div>
              </div>

              <div className="dividerLine"></div>

              <div className="list-items">
                <CartItems />
              </div>
              {extras.length > 0 && <div className="dividerLine"></div>}
              {extras.length > 0 &&
                <div className="options">
                  <h4>Opciones</h4>
                  <ul>
                    {
                      extras.map((extra, i) => {
                        return (
                          <li key={i}>
                            <span className={(extra.activate) ? "fa fa-toggle-on" : "fa fa-toggle-off"} style={{ color: configuration().clientColor }} aria-hidden="true" onClick={() => this.props.activateExtra(extra)}></span> {extra.name}
                            <span className="pull-right price">
                              {typeof extra.price === 'number' && !_.isNaN(extra.price) ? parseFloat(parseFloat(extra.price) * parseFloat(configuration().ivaConfigTaxesSin)).toFixed(2) : '-.-'} €
                            </span>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              }
              {
                Array.isArray(filteredAdditionalServices) && filteredAdditionalServices.length > 0
                  ? (
                    <React.Fragment>
                      <div className="dividerLine"></div>
                      <div className="options">
                        <h4><b>Servicios adicionales</b></h4>
                        <ul>
                          {
                            filteredAdditionalServices.map((additional, i) => {
                              const isSelected = _.find(items, e => e.serviceId === additional.serviceId)
                              return (
                                <li key={i}>
                                  <span className={isSelected ? "fa fa-toggle-on redcolor" : "fa fa-toggle-off"} style={{ color: configuration().clientColor }} aria-hidden="true" onClick={() => this.addAdditionalService(additional)}></span> {additional.name}
                                  <span className="pull-right price">
                                    {typeof additional.price === 'number' && !_.isNaN(additional.price) ? parseFloat(parseFloat(additional.price) * parseFloat(configuration().ivaConfigTaxesSin)).toFixed(2) : '-.-'} € {configuration().ivaConfigTextCon}
                                  </span>
                                </li>
                              )
                            })
                          }
                        </ul>
                      </div>
                    </React.Fragment>
                  )
                  : null
              }
              {items.length > 0 && <div className="dividerLine"></div>}
              {freeItems.length > 0
                ? <div className="extras">
                  {displayIncludeTitle}
                  <ul>
                    {freeItems.map((item, index) => {
                      return (
                        <li key={index}>
                          <span className="tag"
                            style={{ backgroundColor: configuration().clientColor }}>GRATIS</span> {item}
                        </li>
                      )
                    })
                    }
                  </ul>
                </div>
                : null
              }
            </div>
          </div>
          :
          <div className="block-text">
            <h4 className="main-copy">{configuration().cartCopyTop}</h4>
            <ul className={ticksColor} >
              <li>Ahorra tiempo</li>
              <li>Toda la información en tu móvil</li>
              <li>Precios cerrados</li>
              <li>{configuration().garantia} de garantía</li>

            </ul>
            <hr />
            {
              configuration().selloCalidadText
                ?
                <h4 className="main-copy">{configuration().cartCopyBottom} {configuration().selloCalidadText}</h4>
                : null
            }
            {
              configuration().cualityLogo
                ?
                <img src={configuration().cualityLogo} width="124" height="160" className="img-sello" alt="logo" />
                : null
            }
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    appointment: state.checkout.appointment,
    cart: state.checkout.shoppingCart,
    queryParams: state.checkout.checkoutRoot.queryParams,
    nonForfaitBudget: state.checkout.checkoutRoot.nonForfaitBudget,
    additionalServices: state.catalogue.additionalServices,
    currentUser: state.checkout.checkoutContent.currentUser,
    carData: state.checkout.carData.carDataData
  }
}

const bindActions = dispatch => ({
  switchCheckoutContent: content => dispatch(switchCheckoutContent(content)),
  setLimitDateAppointment: tempHoursRange => dispatch(setLimitDateAppointment(tempHoursRange)),
  activateExtra: (extra) => dispatch(activateExtra(extra)),
  toggleAdditionalService: (additionalService) => dispatch(toggleAdditionalService(additionalService)),
  loadInitialsDatePickerValues: () => dispatch(loadInitialsDatePickerValues()),
  addReplacementVehicle: () => dispatch(addReplacementVehicle()),
  removeReplacementVehicle: () => dispatch(removeReplacementVehicle()),
  cleanShoppingCartStore: (props) => dispatch(cleanShoppingCartStore(props)),
  loadFormValues: (form, field, value) => dispatch(change(form, field, value)),
});

export default connect(mapStateToProps, bindActions)(ShoppingCart);



// WEBPACK FOOTER //
// ./src/components/shoppingCart/index.js